import { ReactNode, useState } from 'react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/common/components/ui/dropdown-menu';
import { TableHead } from '@/common/components/ui/table';

import { FilterButton } from './FilterButton';

export interface ColumnHeaderProps {
  label: string;
  sortable?: boolean;
  filterable?: boolean;
  hasActiveFilter?: boolean;
  hasActiveSort?: boolean;
  renderFilterContent: (onClose?: () => void) => React.ReactNode;
  renderSortButton?: () => ReactNode;
  width?: string;
}

export const ColumnHeader = ({
  label,
  sortable = false,
  filterable = false,
  hasActiveFilter = false,
  hasActiveSort = false,
  renderFilterContent,
  renderSortButton,
  width,
}: ColumnHeaderProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);

  const isInteracting = isHovered || isFilterDropdownOpen;
  const shouldShowFilter = filterable && (isInteracting || hasActiveFilter);
  const shouldShowSort = sortable && (isInteracting || hasActiveSort);

  return (
    <DropdownMenu
      open={isFilterDropdownOpen}
      onOpenChange={setIsFilterDropdownOpen}
    >
      <TableHead
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={width}
      >
        <div className="flex items-center justify-between gap-2">
          <span className="flex-1 truncate">{label}</span>
          {(shouldShowFilter || shouldShowSort) && (
            <div className="flex items-center gap-1 shrink-0">
              {filterable && (
                <DropdownMenuTrigger asChild>
                  <FilterButton hasActiveFilter={hasActiveFilter} />
                </DropdownMenuTrigger>
              )}

              {sortable && renderSortButton?.()}
            </div>
          )}
        </div>
      </TableHead>
      {filterable && (
        <DropdownMenuContent className="p-2" align="start">
          {renderFilterContent(() => setIsFilterDropdownOpen(false))}
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
};
